import { createPortal } from 'react-dom'
import { KTSVG } from '_metronic/helpers'

import { Modal } from 'react-bootstrap'

import clsx from 'clsx'
import { PLAN_DETAILS } from '../../Profile/Config'

const PlanDetailCard: React.FC<{
	idx: number
	color: string
	canPurchase: boolean
	planName: string
	planDescription: string
	planPrice: string
	planPriceDescription: string
	listHeader: string
	lists: string[]
}> = ({
	idx,
	color,
	canPurchase,
	planName,
	planPrice,
	planPriceDescription,
	planDescription,
	listHeader,
	lists,
}) => {
	return (
		<div className={`card border border-kumopack-${color} h-100`}>
			<div className="card-body">
				<div className="row gy-5">
					<div className="col-12">
						<div className={`text-kumopack-${color} fw-bold fs-2`}>{planName}</div>
					</div>

					<div className="col-12 h-30px">
						<div className="text-kumopack-grey-700">{planDescription}</div>
					</div>

					<div className="col-12">
						<div className="text-kumopack-grey-900 fs-1 fw-bold">{planPrice}฿</div>
					</div>

					<div className="col-12 h-50px">
						<div className="text-kumopack-grey-500 w-75">{planPriceDescription}</div>
					</div>

					<div className="col-12 h-100px">
						<button
							className={clsx(`btn btn-lg w-100 fw-bold hover-enabled border-radius-4px`, {
								'text-kumopack-base-white btn-kumopack-base-black': idx % 2 !== 0,
								'text-kumopack-base-black bg-kumopack-base-white border-kumopack-base-black border':
									idx % 2 === 0,
							})}>
							Get Started
						</button>
						{canPurchase && (
							<div className="text-kumopack-grey-500 mt-5 text-center fs-6">
								or{' '}
								<span className="text-kumopack-base-black fw-bold text-underline cursor-pointer">
									purchase now
								</span>
							</div>
						)}
					</div>

					<div className="col-12 h-30px">
						<div
							className={clsx({
								'text-kumopack-grey-900 fs-5 fw-bold': idx % 2 !== 0,
								'text-kumopack-grey-500 fs-5 fw-bold': idx % 2 === 0,
							})}>
							{listHeader}
						</div>
					</div>

					<div className="col-12 h-400px">
						{lists.map((l, idx) => (
							<div
								className={clsx('text-kumopack-grey-700 mb-5', {
									'mb-0': idx === lists.length - 1,
									'mt-5': idx === 0,
								})}>
								<img
									src="/media/icons/kumopack/black-check.svg"
									alt="Black Check Icon"
									height={20}
								/>
								{l}
							</div>
						))}
					</div>

					{canPurchase && (
						<div className="col-12 fw-bold cursor-pointer">Learn more about {planName}</div>
					)}
				</div>
			</div>
		</div>
	)
}

const PlanDetailModal: React.FC<{ isOpen: boolean; handleClose: () => void }> = ({
	isOpen,
	handleClose,
}) => {
	const modalsRoot = document.getElementById('root-modals') || document.body

	return createPortal(
		<Modal
			size="xl"
			id="kt_modal_plan_detail"
			tabIndex={-1}
			aria-hidden="true"
			dialogClassName="modal-dialog modal-dialog-centered"
			show={isOpen}
			onHide={handleClose}
			backdrop={true}>
			<div className="modal-content">
				<div className="modal-header w-100">
					<div className="d-flex justify-content-end w-100">
						<div className="btn btn-sm btn-icon btn-active-light-danger" onClick={handleClose}>
							<KTSVG className="svg-icon-1" path="/media/icons/duotune/general/gen040.svg" />
						</div>
					</div>
				</div>

				<div className="modal-body py-lg-10 px-lg-10 min-h-600px">
					<div className="row">
						{PLAN_DETAILS.map((planDetail, idx) => (
							<div className="col-4" key={`plan-detail-card-${planDetail.planName}`}>
								<PlanDetailCard idx={idx} {...planDetail} />
							</div>
						))}
					</div>
				</div>
			</div>
		</Modal>,
		modalsRoot
	)
}

export default PlanDetailModal
